// Define constants for different elements
const desktopTopLevelMenuItems = document.querySelectorAll(
	'#menu-desktop .menu-link-top.has-children'
);

// Function to close all submenus
const closeAllSubmenus = function () {
	// Loop through the submenus
	desktopTopLevelMenuItems.forEach( function ( menuItem ) {
		// Close the submenu
		menuItem.setAttribute( 'aria-expanded', 'false' );
	} );
};

// Loop through the top-level menu items
desktopTopLevelMenuItems.forEach( function ( menuItem ) {

	// Get top level menu section
	let navigation_menu_section = menuItem.innerText;

	// Add a click event listener
	menuItem.addEventListener( 'click', function ( event ) {

		// Store the clicked menu item
		let clickedMenuItem = event.target;

		// Stop the link being followed
		event.preventDefault();

		// Stop propagation up to the body tag
		event.stopPropagation();

		// If this is opening a menu
		if ( clickedMenuItem.getAttribute( 'aria-expanded' ) === 'false' ) {

			// Track the click
			ofhMixpanelTrack(
				'Navigation Menu Clicked',
				{
					'navigation_menu_section': navigation_menu_section
				}
			);

			// Close any open submenus
			closeAllSubmenus();

			// Make aria-expanded true on clicked menu item
			clickedMenuItem.setAttribute( 'aria-expanded', 'true' );

			// Add an event listener on the body for a click on anything else
			document
				.querySelector( 'body' )
				.addEventListener( 'click', closeAllSubmenus );

			// Otherwise this menu needs to close
		} else {
			// Close any open submenus
			closeAllSubmenus();
		}
	} );
} );

// Listen for an escape key being pressed
document.addEventListener( 'keydown', function ( event ) {
	if ( event.key === 'Escape' ) {
		// Close anything that's open
		closeAllSubmenus();
		// Blur to avoid focus state
		desktopTopLevelMenuItems.forEach( function ( menuItem ) {
			menuItem.blur();
		} );
	}
} );
